import { Router } from 'react-router-dom';
import { createBrowserHistory, Location, Action } from 'history';
import { wrapHistory } from 'oaf-react-router';

export const ClientRouter = ({ children }: { children: JSX.Element }) => {
	const history = createBrowserHistory();
	wrapHistory(history, {
		shouldHandleAction(_previous: Location, _next: Location, action?: Action) {
			// when loading more data on a paginated page we REPLACE the history state.
			// don't change scroll position or focus in those cases.
			return action !== 'REPLACE';
		},
		primaryFocusTarget: 'app',
	});

	return <Router history={history}>{children}</Router>;
};
